import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Grid, Col } from '../../../ui-kit';
// Redux imports
import { selectors as combinedScheduleSelectors } from '../../../../state/modules/combined-schedules';
import { selectors as groupSelectors } from '../../../../state/modules/groups';
import { selectors as userSelectors } from '../../../../state/modules/users';
import { selectors as skillSelectors } from '../../../../state/modules/skills';
import { selectors as standbyDutyFunctionSelectors } from '../../../../state/modules/standby-duty-functions';
import { selectors as availabilityCodeSelectors } from '../../../../state/modules/availability-codes';
import { selectors as membershipSelectors } from '../../../../state/modules/memberships';
// Other utilities
import FilterObject from '../shared/Filter/FilterObject';
import Settings from '../shared/Filter/FilterSettings';
import SkillIcon from '../../../general/SkillIcon';
import Loader from '../../../general/Loader';
import UserContact from '../../../general/UserContact';
import { FilterRow } from '../shared/Filter/Styles';

const ContactListWidget = props => {
  const { dashboardAPIManager } = props;

  useEffect(() => {
    dashboardAPIManager.fetchGroups();
    dashboardAPIManager.fetchUsers({ params: { presentation_type: 'basic' } });
    dashboardAPIManager.fetchSkills();
    dashboardAPIManager.fetchMemberships();
    dashboardAPIManager.fetchStandbyDutyFunctions();
    dashboardAPIManager.fetchAvailabilityCodes();
    dashboardAPIManager.registerForCombinedScheduleUpdates({ type: 'membership' });
  }, [dashboardAPIManager]);

  const skillsById = useSelector(skillSelectors.byId);
  const standbyDutyFunctionsById = useSelector(standbyDutyFunctionSelectors.byId);
  const availabilityCodesById = useSelector(availabilityCodeSelectors.byId);
  const initialLoad = useSelector(
    groupSelectors.initialLoadComplete &&
      userSelectors.initialLoadComplete &&
      skillSelectors.initialLoadComplete &&
      standbyDutyFunctionSelectors.initialLoadComplete &&
      availabilityCodeSelectors.initialLoadComplete &&
      membershipSelectors.initialLoadComplete
  );
  const members = useSelector(combinedScheduleSelectors.membershipStatusAtDashboardTime);
  const combinedScheduleLoading = useSelector(combinedScheduleSelectors.loading);

  const filters = useMemo(() => props.filters.map(f => new FilterObject(f)), [props.filters]);

  if (filters.length === 0) return <span>{I18n.t('no_results_found')}</span>;

  if (!initialLoad || combinedScheduleLoading) return <Loader />;

  return (
    <Grid fluid>
      {filters.map((filter, index) => (
        <FilterRow fluid="true" key={index}>
          <Col xs={6} md={6} lg={6}>
            <strong>{filter.title}</strong>
            {filter.skill_ids.map(s => (
              <span className="ms-2" key={s}>
                <SkillIcon skill={skillsById[s]} />
              </span>
            ))}
            {filter.duty_function_ids.map(df => (
              <span className="ms-2" key={df}>
                <SkillIcon skill={standbyDutyFunctionsById[df]} />
              </span>
            ))}
            {filter.availability_code_ids.map(ac => (
              <span className="ms-2" key={ac}>
                <SkillIcon skill={availabilityCodesById[ac]} />
              </span>
            ))}
          </Col>
          <Col xs={6} md={6} lg={6}>
            {filter.some(members) ? (
              filter.filter(members).map(user => (
                <span key={user.id} className="me-2">
                  <UserContact userId={user.id} displayFullName={true} />
                </span>
              ))
            ) : (
              <span>{I18n.t('no_results_found')}</span>
            )}
          </Col>
        </FilterRow>
      ))}
    </Grid>
  );
};

export default Object.assign(ContactListWidget, {
  SettingsContent: Settings,
  defaultSettings: {
    filters: []
  }
});
